// config_names.js
const config_names = {
    projectName: "FactorBench",
    projectName_genitive: "FactorBench's",
    projectDomain: "FactorBench.com",
    allow_skip_login_for_now: false,
    contactEmail: "contact@factorbench.com",
    jurisdiction: "Switzerland",
    operating_country: "Switzerland",
    effectiveDate: "November 13, 2025",
    domain: "https://factorbench.com",
  };
  
  export default config_names;